// Action Types for API Key Registration
export const FETCH_API_KEYS_REQUEST = "FETCH_API_KEYS_REQUEST";
export const FETCH_API_KEYS_SUCCESS = "FETCH_API_KEYS_SUCCESS";
export const FETCH_API_KEYS_FAILURE = "FETCH_API_KEYS_FAILURE";

export const CREATE_API_KEY_REQUEST = "CREATE_API_KEY_REQUEST";
export const CREATE_API_KEY_SUCCESS = "CREATE_API_KEY_SUCCESS";
export const CREATE_API_KEY_FAILURE = "CREATE_API_KEY_FAILURE";

export const GET_API_KEY_REQUEST = "GET_API_KEY_REQUEST";
export const GET_API_KEY_SUCCESS = "GET_API_KEY_SUCCESS";
export const GET_API_KEY_FAILURE = "GET_API_KEY_FAILURE";

export const UPDATE_API_KEY_REQUEST = "UPDATE_API_KEY_REQUEST";
export const UPDATE_API_KEY_SUCCESS = "UPDATE_API_KEY_SUCCESS";
export const UPDATE_API_KEY_FAILURE = "UPDATE_API_KEY_FAILURE";

export const DELETE_API_KEY_REQUEST = "DELETE_API_KEY_REQUEST";
export const DELETE_API_KEY_SUCCESS = "DELETE_API_KEY_SUCCESS";
export const DELETE_API_KEY_FAILURE = "DELETE_API_KEY_FAILURE";

export const LIST_API_KEYS_REQUEST = "LIST_API_KEYS_REQUEST";
export const LIST_API_KEYS_SUCCESS = "LIST_API_KEYS_SUCCESS";
export const LIST_API_KEYS_FAILURE = "LIST_API_KEYS_FAILURE";

export const VALIDATE_API_KEY_REQUEST = "VALIDATE_API_KEY_REQUEST";
export const VALIDATE_API_KEY_SUCCESS = "VALIDATE_API_KEY_SUCCESS";
export const VALIDATE_API_KEY_FAILURE = "VALIDATE_API_KEY_FAILURE";

// Action Creators

// Fetch API Keys
export const fetchApiKeysRequest = (payload) => ({
  type: FETCH_API_KEYS_REQUEST,
  payload,
});

export const fetchApiKeysSuccess = (apiKeys) => ({
  type: FETCH_API_KEYS_SUCCESS,
  payload: apiKeys,
});

export const fetchApiKeysFailure = (error) => ({
  type: FETCH_API_KEYS_FAILURE,
  payload: error,
});

// Create API Key
export const createApiKeyRequest = (payload) => ({
  type: CREATE_API_KEY_REQUEST,
  payload,
});

export const createApiKeySuccess = (apiKey) => ({
  type: CREATE_API_KEY_SUCCESS,
  payload: apiKey,
});

export const createApiKeyFailure = (error) => ({
  type: CREATE_API_KEY_FAILURE,
  payload: error,
});

// Get API Key
export const getApiKeyRequest = (payload) => ({
  type: GET_API_KEY_REQUEST,
  payload,
});

export const getApiKeySuccess = (apiKey) => ({
  type: GET_API_KEY_SUCCESS,
  payload: apiKey,
});

export const getApiKeyFailure = (error) => ({
  type: GET_API_KEY_FAILURE,
  payload: error,
});

// Update API Key
export const updateApiKeyRequest = (payload) => ({
  type: UPDATE_API_KEY_REQUEST,
  payload,
});

export const updateApiKeySuccess = (apiKey) => ({
  type: UPDATE_API_KEY_SUCCESS,
  payload: apiKey,
});

export const updateApiKeyFailure = (error) => ({
  type: UPDATE_API_KEY_FAILURE,
  payload: error,
});

// Delete API Key
export const deleteApiKeyRequest = (payload) => ({
  type: DELETE_API_KEY_REQUEST,
  payload,
});

export const deleteApiKeySuccess = (response) => ({
  type: DELETE_API_KEY_SUCCESS,
  payload: response,
});

export const deleteApiKeyFailure = (error) => ({
  type: DELETE_API_KEY_FAILURE,
  payload: error,
});

// List API Keys
export const listApiKeysRequest = (payload) => ({
  type: LIST_API_KEYS_REQUEST,
  payload,
});

export const listApiKeysSuccess = (apiKeys) => ({
  type: LIST_API_KEYS_SUCCESS,
  payload: apiKeys,
});

export const listApiKeysFailure = (error) => ({
  type: LIST_API_KEYS_FAILURE,
  payload: error,
});

// Validate API Key
export const validateApiKeyRequest = (payload) => ({
  type: VALIDATE_API_KEY_REQUEST,
  payload,
});

export const validateApiKeySuccess = (validationResult) => ({
  type: VALIDATE_API_KEY_SUCCESS,
  payload: validationResult,
});

export const validateApiKeyFailure = (error) => ({
  type: VALIDATE_API_KEY_FAILURE,
  payload: error,
});
